/**
 * Granola connector metadata.
 *
 * Granola exposes a remote MCP server with browser OAuth and Dynamic Client
 * Registration. Tool schemas are discovered at runtime.
 */

module.exports = {
  id:          'granola',
  name:        'Granola',
  enabled:     true,
  iconBg:      '#D7FF4F',
  svgPath:     null,
  svgViewBox:  '0 0 24 24',
  svgPaths: [
    {
      d: 'M12 3.5a8.5 8.5 0 1 0 8.5 8.5c0 3.7-3 6.7-6.7 6.7-2.9 0-5.2-2.3-5.2-5.2 0-2.2 1.8-4 4-4 1.6 0 2.9 1.3 2.9 2.9 0 1.2-1 2.2-2.2 2.2-.8 0-1.5-.7-1.5-1.5',
      fill: 'none',
      stroke: '#152018',
      strokeWidth: 2.35,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],

  tagline:     'Bring meeting notes, decisions, and customer conversations into agent context.',
  description: 'Connect Granola so Pabs can search meeting history, synthesize customer language, identify decisions and action items, and turn recurring evidence into strategic Learnings.',
  useCases: [
    'Find recurring customer problems across interviews and calls',
    'Recover decisions, unresolved questions, and action items from meetings',
    'Compare meeting evidence with assumptions in the product strategy',
    'Turn repeated themes into proposed Learnings for review',
  ],
  accountGuidance: 'Granola MCP follows your active Granola workspace. If expected meetings are missing, ask Pabs which Granola account and workspace are connected.',
};
